export function handleRowClick(event: React.MouseEvent, url: string, push: (path: string) => void) {
  // Don't navigate while the user is selecting text (copy-paste, double-click),
  // since the selection's terminating click lands on the row, not the link.
  if (window.getSelection()?.toString()) return;
  if (event.ctrlKey || event.metaKey) window.open(url, '_blank');
  else push(url);
}

export function handleRowAuxClick(event: React.MouseEvent, url: string) {
  if (event.button === 1) window.open(url, '_blank');
}
